import React from 'react'

const StdDownloadDemandLetter = () => {
  return (
    <div>
      <h1>DownloadDemandLetter</h1>
    </div>
  )
}

export default StdDownloadDemandLetter
